export const loadingMessages = {
  colors: '利用できるカラーを読み込んでいます',
  product: '商品データを読み込んでいます',
  design: 'デザインデータを読み込んでいます',
  cartItem: 'カートの中身を読み込んでいます',
  myDesign: 'マイデザインを読み込んでいます'
} as const
